import { render, staticRenderFns } from "./YedeerStep.vue?vue&type=template&id=0ec674d9&scoped=true&"
import script from "./YedeerStep.vue?vue&type=script&lang=js&"
export * from "./YedeerStep.vue?vue&type=script&lang=js&"
import style0 from "./YedeerStep.vue?vue&type=style&index=0&id=0ec674d9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec674d9",
  null
  
)

export default component.exports